module.exports = __webpack_public_path__ + "img/深圳纪兰芬.7e1c4a9.png";